import { api, Role2 } from 'api';
import { queryCacheDuration } from 'const';
import { rtkQueryApi } from 'store/rtkQueryApi';

export const rolesApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query<Role2[], void>({
      query: () => api.role.getAll(),
      keepUnusedDataFor: queryCacheDuration,
    }),
  }),
});

export const { useGetRolesQuery } = rolesApi;
